/**
 * Known Filter Types for NFTs
 */

export enum NFTFilterTypes {
  MARKETPLACE = 'Marketplace',
  PRICE_RANGE = 'Price Range',
  TRAIT = 'Trait',
}
